import Component from 'vue-class-component';

Component.registerHooks([
    'beforeRouteUpdate',
    'beforeRouteLeave',
    'beforeRouteEnter',
]);
